import AnimationRevealPage from "helpers/AnimationRevealPage";
import { HeaderStyles, ContainerStyles, HeadingStyles, TextStyles } from "styles/style";
import { BasicInfo, AcademicInfo, CareerInfo, SCJCareerInfo } from "components/forms";

export default function FormContent({
  table = null,
  title = null
}) {
  return (
    <AnimationRevealPage>
      <HeaderStyles.ContentStyledHeader />
      <ContainerStyles.Container>
        <ContainerStyles.ContentWithPaddingXl>
          <HeadingStyles.HeadingRow>
            <HeadingStyles.Heading>
              <TextStyles.HighlightedText>
                { title }
              </TextStyles.HighlightedText>
            </HeadingStyles.Heading>
          </HeadingStyles.HeadingRow>
          {(() => {
            switch(table) {
              case 'basic-information':
                return <BasicInfo />;
              case 'academic-information':
                return <AcademicInfo />;
              case 'work-job-career':
                return <CareerInfo />;
              case 'shincheonji-career':
                return <SCJCareerInfo />;
              default:
                return <div>Form not found for: {table}</div>;
            }
          })()}
        </ContainerStyles.ContentWithPaddingXl>
      </ContainerStyles.Container>
    </AnimationRevealPage>

  );
}